import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getCollection, updateDocument } from '../../firebase/firestore';
import Loader from '../../components/common/Loader';
import './AdminPages.css';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const { db } = await import('../../firebase/config');
      
      if (!db) {
        setLoading(false);
        setMessages([]);
        return;
      }

      const data = await getCollection('messages');
      setMessages(data.sort((a, b) => b.createdAt - a.createdAt));
    } catch (error) {
      console.error('Error fetching messages:', error);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (messageId) => {
    try {
      await updateDocument('messages', messageId, { read: true });
      setMessages(messages.map(m => 
        m.id === messageId ? { ...m, read: true } : m
      ));
    } catch (error) {
      console.error('Error updating message:', error);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Messages</h1>
        <p>Contact form submissions</p>
      </div>

      <div className="admin-page-content">
        {messages.length === 0 ? (
          <div className="empty-state-card">
            <p>📭 No messages yet</p>
          </div>
        ) : (
          <div className="messages-grid">
            {messages.map((message, index) => (
              <motion.div
                key={message.id}
                className={`message-card ${!message.read ? 'unread' : ''}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                onClick={() => {
                  setSelectedMessage(message);
                  if (!message.read) markAsRead(message.id);
                }}
              >
                <div className="message-card-header">
                  <h3>{message.name}</h3>
                  {!message.read && <span className="unread-badge">New</span>}
                </div>
                <p className="message-subject">{message.subject}</p>
                <p className="message-preview">{message.message?.substring(0, 100)}...</p>
                <div className="message-meta">
                  <span>📧 {message.email}</span>
                  {message.phone && <span>📞 {message.phone}</span>}
                  <span>📅 {message.createdAt?.toDate?.()?.toLocaleDateString() || 'Recent'}</span>
                </div>
              </motion.div>
            ))}
          </div>
        )}

        {selectedMessage && (
          <div className="message-modal" onClick={() => setSelectedMessage(null)}>
            <div className="message-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setSelectedMessage(null)}>×</button>
              <h2>{selectedMessage.subject}</h2>
              <div className="message-details">
                <p><strong>From:</strong> {selectedMessage.name}</p>
                <p><strong>Email:</strong> {selectedMessage.email}</p>
                {selectedMessage.phone && <p><strong>Phone:</strong> {selectedMessage.phone}</p>}
                <p><strong>Date:</strong> {selectedMessage.createdAt?.toDate?.()?.toLocaleString() || 'Recent'}</p>
              </div>
              <div className="message-body">
                <h3>Message:</h3>
                <p>{selectedMessage.message}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminMessages;
